import '@vfde-brix/button-tiles/dist/styles.css';

import { createButtonTilesComponent } from '@vfde-brix/button-tiles';
import { NO_PATTERN_BUSINESS_LOGIC } from '@vfde-brix/core';

const elements = document.getElementsByClassName('brix-button-tiles');

for (let i = 0, x = elements.length; i < x; i += 1) {

    createButtonTilesComponent(elements[i], NO_PATTERN_BUSINESS_LOGIC);

}
